import React from 'react'
import { Bar } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import { ChartProps } from 'react-chartjs-2/dist/types'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
)

interface BarChartProps extends ChartProps<'bar'>{
  height?: number
}

const BarChart: React.FC<BarChartProps> = (props) => {
  return (
    <Bar
      data={props.data}
      options={props.options}
      height={props.height || 150}
    />
  )
}
export default BarChart
